import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Tickets } from '../tickets';

@Component({
    selector: "app-attachment-dialog",
    templateUrl: "./attachment-dialog.component.html",
    styleUrls: ["./attachment-dialog.component.scss"],
})
export class AttachmentDialogComponent implements OnInit {
    attachmentData: any;
    selectedIndex: number = 0;

    constructor(
        public dialogRef: MatDialogRef<AttachmentDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {}

    ngOnInit(): void {
        this.attachmentData = this.data.upload_file;
        // console.log(this.attachmentData);
    }

    selectFile(index: number) {
        this.selectedIndex = index;
    }

    onNoClick(): void {
        this.dialogRef.close();
    }

    prevAttachment(): void {
        if (this.selectedIndex > 0) {
            this.selectedIndex--;
        }
    }

    nextAttachment(): void {
        if (this.selectedIndex < this.attachmentData.length - 1) {
            this.selectedIndex++;
        }
    }
}
